<template>
  <div
    :style="{ 'background-color': `${BGColorContent}`, 'width': `${mainFormWidth}px` }"
    style="min-height: calc(100vh);"
  >
    <menu-header
      v-if="name"
      :name="name"
      :isSecundary="isSecundary"

    />
    <div v-if="desktopView">
      <v-layout
        wrap
        v-for="(row, indexRows) in desktopView"
        :key="`rows${indexRows}`"
      >
        <v-flex
          v-for="(column, indexColumn) in row.Columns"
          :key="`column${indexColumn}`"
          v-bind="{ [column.Type]: true }"
        >
          <div 
            v-for="item in column.Contents"
            :key="`content${item.ID}`"
          >
            <!-- {{item}} -->
            <items
              :item="item"
              :menuID="menu.ID"
              :isMobile="false"
              :columnType="column.Type"
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-else
      v-for="item in isSimulation && editTMP && id === editTMP.ID && contents ? contents : apiContents"
      :key="`content${item.ID}`"
    >
      <items
        :item="item"
        :menuID="menu.ID"
        :isMobile="false"
      />
    </div>
    <div ref="mark" class="text-center py-4">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="grey"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import MenuHeader from '../MenuHeader'
  import api from '@/services/api'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import Items from '@/components/Items.vue'
  import dview from '@/services/dview-service'
  export default {
    components: {
      MenuHeader,
      Items
    },
    props: {
      menu: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      rdv: null,
      apiContents: [],
      isSecundary: false,
      name: null,
      desktopView: null,


      loading: false,
      page: 1,
      count: 0,
      itemsPerPage: 20,
      apiContents: [],
      endData: false,
      obs: null,
      attemptLimit: 30,
    }),
    computed: {
      ...mapState('app',['editTMP', 'contents', 'BGColorContent', 'ColorContent', 'mainFormWidth']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      touchPublic () {
         return this.$route.query.touchPublic ? true : false
      },
      title () { return 2 }
    },
    watch: {
      menu: {
        handler: function (newValue) {
          this.isSecundary = newValue.isSecundary
          this.name = newValue.Name
          this.init()
        },
        deep: true
      }
    },
    mounted () {
      this.rdv = null
      this.isSecundary = this.menu.isSecundary
      this.name = this.menu.Name
      this.initObs()
      this.init()
    },
    beforeDestroy() {
      if (this.obs) {
        this.obs.disconnect()
      }
    },
    methods: {
      initObs () {
        const options = {
          root: null, // Usa la pantalla completa (viewport) como referencia de scroll
          //rootMargin: '0px',
          rootMargin: '0px 0px 150px 0px', 
          threshold: 0.1 // Se activa en cuanto asoma un 10% del div en pantalla
        };

        this.obs = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.loading && !this.endData) {
              this.handleNextPage()
            }
          })
        }, options)

        if (this.$refs.mark) {
          this.obs.observe(this.$refs.mark)
        }
      },
      async init () {
        this.desktopView = null
        this.attemptLimit = 100
        this.page = 1
        this.count = 0
        this.endData = false
        this.apiContents = []
        this.handleGetDesktopView()
      },
      handleNextPage () {
        this.page++
        this.getContent()
      },
      async handleGetDesktopView () {
        try {
          this.loading = true
          this.rdv = await new Promise((resolve, reject) => api.getAll(`menus/desktop-view`, false, null, null, null, this.menu.ID).then(response => {
            resolve(response && response.struct ? JSON.parse(response.struct) : null)
          }))
          this.getContent()
        } catch (error) {
          console.log(error)
        }
      },
      async getContent() {
        try {
          this.loading = true
          this.attemptLimit--
          if (this.attemptLimit <= 0) {
            this.endData = true
            return
          }
          //const contents = await new Promise((resolve) => api.getAll(`contents`, false, null, null, null, this.menu.ID).then(response => {
          const body = {
            page: this.page,
            itemsPerPage: this.itemsPerPage
          }
          const contents = await new Promise((resolve, reject) => api.put(`contents`, false, this.menu.ID, body).then(response => {
            if (!response || !response.data) {
              this.endData = true
              return resolve([])
            }
            if (this.touchPublic) {
              response.data = response.data.filter(x => !x.HideTotem)
            }

            response.data = response.data.map(item => {
              item.IsActive = dview.isActive(item)
              return (item)
            }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation)

            resolve(response.data)
          }))
          if (!contents) this.endData = true
          else {
            this.apiContents.push(...contents)
          }

           this.$nextTick(() => {
            if (this.$refs.mark) {
              const rect = this.$refs.mark.getBoundingClientRect()
              const isVisible = rect.top < window.innerHeight

              // Si sigue visible en la pantalla del usuario, llamamos otra vez a la API inmediatamente
              if (isVisible && !this.endData) {
                this.handleNextPage()
              }
            }
          })
          //this.apiContents.push(...contents)
          if (this.rdv) {
            const ids = []
            for (let i = 0; i < this.rdv.length; i++) {
              for (let j = 0; j < this.rdv[i].Columns.length; j++) {
                for (let k = 0; k < this.rdv[i].Columns[j].Contents.length; k++) {

                  const aux = this.apiContents.filter(x => x.ID === this.rdv[i].Columns[j].Contents[k].ID).shift()
                  if (aux) {
                    this.rdv[i].Columns[j].Contents[k] = aux
                    ids.push(this.rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                  }
                  //rdv[i].Columns[j].Contents[k] = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID) [0]
                  //ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                } 
              } 
            }
            // Añadimos al una fila al final para todo el contenido no actualizado
            this.rdv.push({
              Columns: [
                {
                  Type: 'xs12',
                  Contents: this.apiContents.filter(x => ids.indexOf(x.ID) < 0)
                }
              ]
            })
          }
          this.desktopView = this.rdv
          this.loading = false
          return
          /*
            api.getAll(`menus/desktop-view`, false, null, null, null, this.menu.ID).then(responseDesktopView => {
              console.log('ñññ', responseDesktopView)
              let rdv = responseDesktopView.struct ? JSON.parse(responseDesktopView.struct) : null
              if (rdv) {
                const ids = []
                for (let i = 0; i < rdv.length; i++) {
                  for (let j = 0; j < rdv[i].Columns.length; j++) {
                    for (let k = 0; k < rdv[i].Columns[j].Contents.length; k++) {

                      const aux = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID).shift()
                      if (aux) {
                        rdv[i].Columns[j].Contents[k] = aux
                        ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                      }
                      //rdv[i].Columns[j].Contents[k] = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID) [0]
                      //ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                    } 
                  } 
                }
                // Añadimos al una fila al final para todo el contenido no actualizado
                rdv.push({
                  Columns: [
                    {
                      Type: 'xs12',
                      Contents: this.apiContents.filter(x=>ids.indexOf(x.ID) < 0)
                    }
                  ]
                })
              }
              this.desktopView = rdv
            })
            // api.getAll(`contents`, false, null, null, null, id).then(response => {
            //   this.apiContents = response 
            // })
          })
          .finally(() => {
            alert('aaa')
            this.loading = false
          })
          */
        } catch (error) {
          console.log('error', error)
          this.loading = false
        }
      },
    }
  }
</script>
<style scoped>
</style>
